import React from 'react';

import { Navigate, useLocation, useNavigate, useRoutes } from 'react-router-dom';

import jwt from 'jsonwebtoken';
import { toast } from 'react-hot-toast';
import Cookies from 'universal-cookie';
import { decrypt } from './utils/decryptor';

// layouts
import DashboardLayout from './layouts/dashboard';
//
import AddUser from './pages/AddUser';
import Aplikasi from './pages/Aplikasi';
import AplikasiCreator from './pages/AplikasiCreator';
import Blog from './pages/Blog';
import DashboardApp from './pages/DashboardApp';
import LandingPage from './pages/LandingPage';
import Login from './pages/Login';
import Manual from './pages/Manual';
import NotFound from './pages/Page404';
import PDFPage from './pages/PDFPage';
import PDFScan from './pages/PDFScan';
import PDFShorlinkListener from './pages/PDFShorlinkListener';
import Products from './pages/Products';
import Profile from './pages/Profile';
import Register from './pages/Register';
import ReportsRekomendasi from './pages/ReportsRekomendasi';
import Requestspage from './pages/RequestsPage';
import ServicesCheckRekomendasi from './pages/ServicesCheckRekomendasi';
import ServicesDetailPage from './pages/ServicesDetailPage';
import ServicesPage from './pages/ServicesPage';
import Setting from './pages/Setting';
import SsoLogin from './pages/SsoLogin';
import Token from './pages/Token';
import UAT from './pages/UAT';
import UATCreator from './pages/UATCreator';
import UATResponder from './pages/UATResponder';
import User from './pages/User';
// ----------------------------------------------------------------------

export default function Router() {
  const location = useLocation();
  const navigate = useNavigate();
  const [user, setUser] = React.useState({});
  const cookies = new Cookies();

  React.useEffect(() => {
    if (cookies.get('token')) {
      const decoded = jwt.decode(decrypt(cookies.get('token')));
      setUser(decoded);
    } else {
      const locationSplit = location.pathname.split('/');
      const locationIndex = ['DEVELOPMENT', 'STAGING'].includes(process.env.REACT_APP_STAGE)
        ? 1
        : 1;
      if (locationSplit[locationIndex] === 'dashboard') {
        toast.error('Maaf, Anda tidak memiliki akses');
        navigate(
          ['DEVELOPMENT', 'STAGING'].includes(process.env.REACT_APP_STAGE) ? '/' : '/',
          'replace'
        );
      }
      setUser({});
    }
  }, [location.pathname]);

  return useRoutes(
    [
      {
        path: '/dashboard',
        element: <DashboardLayout user={user} />,
        children: [
          { element: <Navigate to="/dashboard/app" replace /> },
          { path: 'app', element: <DashboardApp user={user} /> },
          { path: 'blog', element: <Blog /> },
          { path: 'manual', element: <Manual /> },
          { path: 'products', element: <Products /> },
          { path: 'profile', element: <Profile user={user} /> },
          { path: 'requests', element: <Requestspage user={user} /> },
          { path: 'services', element: <ServicesPage user={user} /> },
          { path: 'services/:id', element: <ServicesDetailPage user={user} /> },
          { path: 'services/check/:id', element: <ServicesCheckRekomendasi user={user} /> },
          { path: 'reports/rekomendasi', element: <ReportsRekomendasi user={user} /> },
          { path: 'token', element: <Token user={user} /> },
          { path: 'uat', element: <UAT user={user} /> },
          { path: 'uat/:id', element: <UATCreator user={user} /> },
          { path: 'aplikasi', element: <Aplikasi user={user} /> },
          { path: 'aplikasi/:id', element: <AplikasiCreator user={user} /> },
          { path: 'user', element: <User /> },
          { path: 'user/add', element: <AddUser /> },
          { path: 'user/add/:userID', element: <AddUser /> },
          { path: '*', element: <Navigate to="/404" replace /> },
          { path: 'setting', element: <Setting user={user} /> }
        ]
      },
      {
        path: '/login',
        element: <Login />,
        children: [
          { path: 'register', element: <Register /> },
          { path: '*', element: <Navigate to="/404" replace /> }
        ]
      },
      {
        path: '/login-sso',
        element: <SsoLogin />
      },
      {
        path: '/',
        element: <LandingPage user={user} />
      },
      {
        path: '/pdf/:id/:token',
        element: <PDFPage user={user} />
      },
      {
        path: '/pdf/share/:id/:token',
        element: <PDFPage user={user} />
      },
      {
        path: '/pdf/shortlink/:id',
        element: <PDFShorlinkListener user={user} />
      },
      {
        path: '/pdfscan',
        element: <PDFScan user={user} />
      },
      {
        path: '/uat',
        children: [
          { path: 'form/:id', element: <UATResponder user={user} type="answer" /> },
          { path: 'preview/:id', element: <UATResponder user={user} type="preview" /> },
          {
            path: 'response/:id/:idresponse',
            element: <UATResponder user={user} type="response" />
          }
        ]
      },
      {
        path: '/404',
        element: <NotFound />
      },
      { path: '*', element: <Navigate to="/404" replace /> }
    ],
    { basename: ['DEVELOPMENT', 'STAGING'].includes(process.env.REACT_APP_STAGE) ? '' : '' }
  );
}
